import React from 'react';
import classnames from 'classnames';

import { ISocialIcon, SocialMediaIcons, ICON_SIZES } from './types';
import { ISocialIcons } from '../../../../region-types/follow/index';

import * as style from './styles.scss';

import { SocialIconsDataHooks } from './social-icons-datahooks';
import { BdiWrapper } from '../../utils/bdi-wrapper';

export const SocialIconsProps = [
  'label',
  'socialButtons',
  'styles',
  'iconColor',
];

const SocialIcon: React.FunctionComponent<ISocialIcon> = ({
  name,
  url,
  styles,
  iconColor,
}) => {
  const size = styles.size ? ICON_SIZES[styles.size] : ICON_SIZES.medium;
  const Icon = SocialMediaIcons[name];

  return (
    <a
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      data-hook={`${SocialIconsDataHooks.socialIconsUrl}${name}`}
      className={classnames(
        'so-global-region-follow-icon',
        style.icon,
        style[size],
      )}
      style={{
        fill: iconColor,
      }}
    >
      <Icon />
    </a>
  );
};

export const SocialIcons: React.FunctionComponent<
  ISocialIcons & {
    iconColor: string;
  }
> = ({ label, socialButtons, styles, iconColor }) => {
  const fontFamilyStyle = styles.fontFamily
    ? {
        fontFamily: styles.fontFamily,
      }
    : {};
  const color = styles.color ? { color: styles.color } : {};

  return (
    <div className={style.root}>
      {label && (
        <span
          style={{ ...fontFamilyStyle, ...color }}
          className={classnames('lp-style-h3 so-global-h3', style.title)}
          data-hook={SocialIconsDataHooks.socialIconsTitle}
        >
          <BdiWrapper text={label} />
        </span>
      )}
      <span
        className={classnames('so-global-footer-icon', style.iconContainer)}
      >
        {socialButtons.map((buttonConfig) => {
          if (buttonConfig.active) {
            const socialIcon = (
              <SocialIcon
                {...buttonConfig}
                styles={styles}
                iconColor={iconColor}
              />
            );
            return socialIcon;
          }

          return null;
        })}
      </span>
    </div>
  );
};
